<template>
  <tr>
    <td>
      <table>
        <thead>
          <tr>
            <th v-text="'Field'" />
            <th v-text="'Value'" />
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(value, key) in contents"
            :key="key"
          >
            <th v-html="key" />
            <td v-html="value" />
          </tr>
        </tbody>
      </table>
    </td>
    <td>
      <table>
        <thead>
          <tr>
            <th v-text="'Message'" />
            <th v-text="'Time'" />
            <!--<th>Action</th>-->
          </tr>
        </thead>
        <tr
          v-for="(log, index) in logs"
          :key="`log-${index}`"
        >
          <td :class="logClass(log.attributes.level)">
            <span v-html="log.attributes.message" />
          </td>
          <td
            :class="logClass(log.attributes.level)"
            v-html="log.attributes.created_at"
          />
          <!--<td :class="logClass(log.attributes.level)"></td>-->
        </tr>
      </table>
    </td>
  </tr>
</template>

<script type="text/babel">
export default {
  name: 'ImportWarningRow',
  props: {
    row: {
      type: Object,
      required: true,
    },
  },
  computed: {
    contents() {
      return this.row.attributes.contents
    },
    logs() {
      return this.row.logs.data
    },
  },
  methods: {
    logClass(level) {
      switch (level) {
        case 'success':
          return ''
        case 'warning':
          return 'bg-yellow'
      }
    },
  },
}
</script>
